// removed by extract-text-webpack-plugin
module.exports = {"SectionTitle":"FinalResult__SectionTitle__2jX-o","Forward":"FinalResult__Forward__kWGmq","Note":"FinalResult__Note__1sJ_g","Link":"FinalResult__Link__1pFqJ","Result":"FinalResult__Result__ieO7I","RankedUsers":"FinalResult__RankedUsers__2QQwX","RankedUser":"FinalResult__RankedUser__-8ja7","Winner":"FinalResult__Winner__15ySx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Stage/FinalResult/FinalResult.css
// module id = 407
// module chunks = 0